import { type StyleSheet } from '@blaze-shared/theming-domain';

export interface FindMatchingStyleSheetParams {
  id?: string;
  name?: string;
  elementType?: string;
  sheets: StyleSheet[];
}

export function findMatchingStyleSheet({
  id,
  name,
  elementType,
  sheets,
}: FindMatchingStyleSheetParams): StyleSheet | undefined {
  if (!id && !name) {
    return undefined;
  }
  const themeById = sheets.find((s) => s.id === id && !s.themeId && s.elementType === elementType);
  if (id && themeById) {
    return themeById;
  }
  return sheets.find((s) => s.name === name && s.themeId && s.elementType === elementType);
}

export function isStyleGlobal(styleSheet: StyleSheet | null | undefined): boolean {
  if (!styleSheet) {
    return false;
  }
  return !!styleSheet.id && !styleSheet.themeId;
}
